<template src="./messageConversationDetail.template.html"></template>
<script>
    import moment from "moment-timezone";
    import Fuse from 'fuse.js'
    import tippy from 'tippy.js'
    import Icon from '../../notificationTemplates/components/Icon'
    import { Editor, EditorContent, EditorMenuBar } from 'tiptap'

    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
        Mention,
        Placeholder,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Image
    } from 'tiptap-extensions'
    export default {
        components: {
            EditorContent,
            EditorMenuBar,
            Icon,
        },
        name: "messageConversationDetail",
        props: ["conversationId", "parentCallback", "messageFilterType", "updateReplymessage", "reservationId"],
        data() {
            return {
                messages: [],
                temp: {
                    old_unique_date: null
                },
                formats: {
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    nextWeek: 'dddd',
                    lastDay: '[Yesterday]',
                    lastWeek: 'dddd',
                    sameElse: 'DD MMM YYYY'
                },
                guestInfo: {},
                previousConversationId: null,
                previousMessageFilterType: "",
                unreadMessageText: false,
                groupedMessagesList: {},
                messageToSend: "",
                lastMessageObject: {},
                scrollTimer: -1,
                sendSourceOptionsList: [
                    // {
                    //     SourceName: "Airbnb",
                    //     sourceId: 1,
                    // },
                    // {
                    //     SourceName: "Mail",
                    //     sourceId: 2
                    // },
                ],
                selectedSendSource: 1,
                showTemplateList: false,
                templateList: [],
                selectedTemplate: null,
                templateDetail: {},
                updateMessageToSend: "",
                previousConversationReplyStatus: "",
                editor: null,
                selectedParam: {},
                repliedUsersList: [],
                messageToSendTextvals: "",
                notifications: [],
                messages_notifications_list: [],
                botMessagesList: [],
                sendShowHide: true,
                footerHeightString: null,
                elemHtml: null,
                options: {
                    scrollbars: true,
                    interactiveScrollbars: true,
                    probeType: 3,
                    mouseWheel: true,
                    mouseWheelSpeed: 1
                },
                variable: false,
                totalLength: null,
                pullDownTextObj: {
                    trigger: 'Loading...',
                    begin: 'Loading...',
                    complete: 'There are no items',
                    error: 'There is server error',
                    refresh: 'Loading...'
                },
                PageNumber: 1,
                changedGroupedMessagesList: []
            }
        },

        methods: {
            getMoreData($stateChange) {
                if (this.changedGroupedMessagesList.length >= this.totalLength) {
                    $stateChange('complete')
                } else {
                    this.loading = false;
                    this.PageNumber++;
                    vm.GetConversationMessageList(vm.conversationId);
                }
            },
            refreshData($pullStateChange) {
                setTimeout(() => {
                    this.changedGroupedMessagesList.splice(0)
                    for (let i = 0; i < 50; i++) {
                        this.changedGroupedMessagesList.push({
                            text: i,
                            id: i,

                        })
                    }
                    $pullStateChange('complete')
                }, 1500)
            },
            showEmailContent(htmlcontent) {
                var win = window.open();
                // "", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=" + (screen.height - 400) + ",left=" + (screen.width - 840)
                win.document.body.innerHTML = htmlcontent;

            },
            // groupByDate(date) {
            //     var old_date = this.temp.old_unique_date;
            //     var new_date = new Date(date).getDate();
            //     if (old_date != new_date) {
            //         this.temp.old_unique_date = new_date;
            //         var day = ("0" + new Date(date).getDate()).slice(-2);
            //         var month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
            //         var date_data = day + "/" + month;
            //         return date_data;
            //     } else {
            //         return "";
            //     }
            // }
            chartCountLength(message) {
                if (message && message.length > 100) {
                    return 'charCount'
                }
                else {
                    return ''
                }
            },
            groupByDate(date) {
                // const year = new Date(date).getFullYear();
                // const day = (`0${new Date(date).getDate()}`).slice(-2);
                // const month = (`0${new Date(date).getMonth() + 1}`).slice(-2);
                // const date_data = `${year}.${month}.${day}`;
                let momentDate = moment(date).format("YYYY MMM DD");
                if (this.old_unique_date === momentDate) {
                    return "";
                }
                this.old_unique_date = momentDate
                let result = '';
                result += `<div class="chat-day-title">`
                result += `<span class="title">`
                result += moment(momentDate).calendar(null, this.formats);
                result += `</span>`
                result += `</div>`
                return result;
                // moment(momentDate).calendar(null, this.formats)
                // console.log("this.old_unique_date = date_data == ",moment(momentDate).calendar(null, this.formats))
                // console.log("this.old_unique_date", this.old_unique_date, "==", date_data, "result", moment().calendar(date, this.formats))
                // result += `<div class="chat-date text-center relative-position">`;
                // result += `<span class="line inline-b"></span>`;
                // result += `<span class="inline-b bg-white txt-13 text-grey-6 pd-5 absolute-center">`;
                // // eslint-disable-next-line no-multi-assign,no-return-assign
                // result += this.old_unique_date = date_data;
                // result += `</span>`;
                // result += `</div>`;
                // eslint-disable-next-line no-multi-assign,no-return-assign
                // return this.old_unique_date = date_data;

            },
            GetConversationMessageList(conversationId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetConversationMessageList",
                    params: {
                        ConversationId: conversationId ? conversationId : vm.conversationId,
                        ReservationId: vm.reservationId ? vm.reservationId : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetConversationMessageList", err);
                            return;
                        }
                        if (response) {
                            console.log("response in GetConversationMessageList", response);
                            
                            vm.$store.commit("setRefreshMessageNotificationPanel", false);
                            vm.messages.splice(0, vm.messages.length, ...response[1]);
                            vm.notifications.splice(0, vm.notifications.length, ...response[2]);
                            vm.botMessagesList.splice(0, vm.botMessagesList.length, ...response[4]);
                            vm.repliedUsersList.splice(0, vm.repliedUsersList.length, ...response[3])
                            vm.notifications = vm.notifications.filter(notif => notif.Messagecontent != null && notif.Messagecontent != "")
                            if (vm.messages.length > 0) {
                                vm.guestInfo = {
                                    guestName: `${vm.messages[0].GuestFirstName} ${vm.messages[0].GuestLastName}`,
                                    guestProfileId: vm.messages[0].GuestProfileId,
                                    noOfStays: vm.messages[0].CountofStays,
                                    initials: vm.messages[0].Initials
                                }
                            }

                            vm.messages_notifications_list = vm.messages.concat(vm.notifications);
                            if (vm.botMessagesList.length > 0) {
                                vm.botMessagesList = vm.botMessagesList.map((message) => {
                                    let messageobject = {
                                        DateCreated: message.UpdatedDate ? message.UpdatedDate : message.CreatedDate ? message.CreatedDate: null,
                                        GuestName: "Bot",
                                        GuestNameInitials: "B",
                                        IsBotMessage: true,
                                        IsGuest: false,
                                        Message: message.EmailContent ? JSON.parse(message.EmailContent).MessageBody : "",
                                        IsMessagesRead: true,
                                        botId: message.BotId
                                    }
                                    return messageobject
                                })
                                vm.botMessagesList = vm.botMessagesList.sort(function (a, b) {

                                    return new Date(a.DateCreated) - new Date(b.DateCreated);
                                });
                                console.log("botMessagesList = ", vm.botMessagesList.length)
                                let messageDetailVal = null, botId = null
                                vm.botMessagesList = vm.botMessagesList.filter(msg => {
                                    if (msg.DateCreated && msg.Message && msg.Message !== messageDetailVal) {
                                        console.log(msg.botId, "=", msg.Message)
                                        messageDetailVal = msg.Message;
                                        botId = msg.botId
                                        return msg
                                    }
                                })
                                console.log("botMessagesList = ", vm.botMessagesList.length)
                                vm.messages_notifications_list = vm.messages_notifications_list.concat(vm.botMessagesList)
                            }

                            vm.messages_notifications_list = vm.messages_notifications_list.sort(function (a, b) {

                                return new Date(a.DateCreated) - new Date(b.DateCreated);
                            });
                            // vm.messages_notifications_list.slice().sort((a, b) => new Date(b.DateCreated) - new Date(a.DateCreated))
                            vm.unreadMessageText = false
                            // if ((vm.messageFilterType == "all" || vm.messageFilterType == "notResponded") && vm.previousMessageFilterType != "unread") {
                            if (vm.messageFilterType == "all" || vm.messageFilterType == "notResponded") {
                                vm.UpdateMessageStatus(conversationId);
                            }
                            // else if ((vm.messageFilterType == "all" || vm.messageFilterType == "notResponded") && vm.previousMessageFilterType == "unread") {
                            //     vm.UpdateMessageStatus(vm.previousConversationId);
                            // }
                            else if (vm.messageFilterType == "unread") {
                                vm.UpdateMessageStatus(vm.previousConversationId);
                            }
                            if (vm.messageFilterType == "notResponded" && vm.previousConversationId && vm.previousConversationReplyStatus) {
                                vm.$store.state.bus.$emit("updatePreviousItem", { ConversationId: vm.previousConversationId });
                            }
                            // vm.UpdateMessageStatus(conversationId);
                            let lastGuestName, guestNameKey = "", lastMessageDate;
                            vm.groupedMessagesList = {}
                            let old_date = null
                            this.totalLength = vm.messages_notifications_list.length
                            vm.messages_notifications_list.forEach((msg, index) => {
                                vm.$set(msg, "showMoreMessage", true);
                                vm.$set(msg, "indexval", index);
                                vm.$set(msg, "contentheight", 0);
                                let momentDate = moment(msg.DateCreated).format("YYYY MMM DD");
                               
                                let dateText = ""
                                if (old_date != momentDate) {
                                    old_date = momentDate
                                    dateText += `<div class="chat-day-title">`
                                    dateText += `<span class="title">`
                                    dateText += moment(momentDate).calendar(null, vm.formats)
                                    dateText += `</span>`
                                    dateText += `</div>`
                                }
                                vm.$set(msg, "dateText", dateText);
                                let result = ""
                                if (!msg.IsMessagesRead && !vm.unreadMessageText && !msg.NotificationId) {
                                    vm.unreadMessageText = true
                                    result += `<div class="chat-day-title" id="unreadMessageTitle">`
                                    result += `<span class="title">`
                                    result += 'Unread Messages';
                                    result += `</span>`
                                    result += `</div>`
                                }
                                vm.$set(msg, "result", result);

                                let msgDate = moment(msg.DateCreated).format("YYYY-MM-DD")
                                if (msg.GuestName !== lastGuestName) {
                                    guestNameKey = `${msg.GuestName}_${index}`
                                    vm.groupedMessagesList[guestNameKey] = {};
                                    vm.groupedMessagesList[guestNameKey].data = msg
                                    vm.groupedMessagesList[guestNameKey].messages = []

                                    lastGuestName = msg.GuestName;
                                    lastMessageDate = moment(msg.DateCreated).format("YYYY-MM-DD");
                                }
                                else if (msg.GuestName == lastGuestName && !moment(msgDate).isSame(lastMessageDate)) {
                                    guestNameKey = `${msg.GuestName}_${index}`
                                    vm.groupedMessagesList[guestNameKey] = {};
                                    vm.groupedMessagesList[guestNameKey].data = msg
                                    vm.groupedMessagesList[guestNameKey].messages = []

                                    lastGuestName = msg.GuestName;
                                    lastMessageDate = moment(msg.DateCreated).format("YYYY-MM-DD");
                                }
                                
                                vm.groupedMessagesList[guestNameKey].messages.push(msg);
                               
                                
                            });
                            vm.changedGroupedMessagesList.splice(0)
                            vm.changedGroupedMessagesList = Object.values(vm.groupedMessagesList)
                            console.log("vm.changedGroupedMessagesList = ",vm.changedGroupedMessagesList)
                            vm.$nextTick(function () {
                                // DOM updated
                                vm.scroll_bottom();
                                vm.getRefs()
                                
                            });


                            vm.GetLastMessageList()

                        
                        }
                    }
                });
            },
            handelScroll() {
                let vm = this
                const topLabel = document.getElementById('date-label')
                topLabel.style.visibility = "visible"
                const messageBox = $('.guest-chat-body')
                // const messageBox = document.getElementById('messages')
                messageBox.on('scroll', function () {
                    // console.log("messageBox.scrollTop === ", messageBox.scrollTop)
                    // messageBox.addEventListener('scroll', () => {
                    $(".divider").addClass("sticky");
                    const dateLabels = document.querySelectorAll('.messageDates')
                    let currentLabel = null
                    dateLabels.forEach((dateLabel) => {

                        // console.log("dateLabel.innerText === ", dateLabel.innerText)
                        if (messageBox.scrollTop() >= dateLabel.offsetTop - 200 && dateLabel.innerText) {
                            // console.log("messageBox.scrollTop === ", messageBox.scrollTop())
                            // console.log("dateLabel.offsetTop === ", dateLabel.offsetTop)
                            // console.log("dateLabel.innerText === ", dateLabel.innerText)
                            currentLabel = dateLabel
                        }
                    })
                    // console.log("currentLabel === ", currentLabel.innerText)
                    if (currentLabel) {
                        topLabel.style.opacity = '1'
                        topLabel.innerText = currentLabel.innerText

                        // console.log("topLabel.innerText === ", topLabel.innerText)
                    } else {
                        topLabel.style.opacity = '0'
                    }
                    if (vm.scrollTimer != -1) {
                        clearTimeout(vm.scrollTimer);
                    }

                    vm.scrollTimer = setTimeout(vm.scrollFinished, 500);
                })
            },
            scrollFinished() {
                const topLabel = document.getElementById('date-label')
                topLabel.style.visibility = "hidden"
            },
            GetLastMessageList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetLastMessageList",
                    params: {
                        ConversationId: vm.conversationId,
                        ReservationId: vm.reservationId ? vm.reservationId : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetLastMessageList", err);
                            return;
                        }
                        if (response) {
                            console.log("GetLastMessageList res=", response)
                            vm.sendSourceOptionsList.splice(0)

                            if (response[1] && response[1].length > 0) {
                                vm.lastMessageObject = response[1][0]

                                // if (vm.lastMessageObject.IsUseremailexists) {
                                //     vm.sendSourceOptionsList.push({
                                //         SourceName: "Mail",
                                //         sourceId: 2
                                //     })
                                // }
                                // if (vm.lastMessageObject.IsPlatformemailexists) {
                                //     vm.sendSourceOptionsList.push({
                                //         SourceName: "Airbnb",
                                //         sourceId: 1
                                //     })
                                // }

                                if (response[1][0].SourceId) {
                                    vm.selectedSendSource = response[1][0].SourceId
                                }
                                // if (response[1][0].SourceId == 1) {
                                //     vm.selectedSendSource = 2
                                // } else if (response[1][0].SourceId == 5) {
                                //     vm.selectedSendSource = 1
                                // }
                                vm.previousConversationReplyStatus = vm.lastMessageObject.IsMessageReplied
                            }
                            vm.sendSourceOptionsList.splice(0, vm.sendSourceOptionsList.length, ...response[2])
                            for (let source of vm.sendSourceOptionsList) {
                                if (source.SourceId == 1) {
                                    vm.$set(source, "Isexists", vm.lastMessageObject.IsUseremailexists)
                                } else {
                                    vm.$set(source, "Isexists", vm.lastMessageObject.IsPlatformemailexists)
                                }
                            }
                        }
                    }
                })
            },
            scroll_bottom() {
                var container = $('.guest-chat-body'),
                    scrollTo = $('#unreadMessageTitle');
                if (scrollTo.length) {
                    // container.animate({
                    //     scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop() - 50
                    // });
                    $("#chat-body").scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop() - 50);
                } else {
                    $("#chat-body").scrollTop($('#chat-body')[0].scrollHeight);
                    $(".guest-chat-body").scrollTop($('.guest-chat-body')[0].scrollHeight);
                    // $(".guest-chat-body").stop().animate({ scrollTop: $(".guest-chat-body")[0].scrollHeight}, 1000);
                }
            },
            unreadMessagesIndicator(unreadMessage) {
                // setTimeout(function () {
                let result = ""
                if (!unreadMessage && !this.unreadMessageText) {
                    this.unreadMessageText = true
                    result += `<div class="chat-day-title">`
                    result += `<span class="title">`
                    result += 'Unread Message(s)';
                    result += `</span>`
                    result += `</div>`

                    return result
                } else {
                    return ""
                }
                // }, 2000);
            },
            UpdateMessageStatus(conversationId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "UpdateMessageStatus",
                    params: {
                        ConversationId: conversationId,
                        StatusId: 1
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("UpdateMessageStatus", err);
                            return;
                        }
                        if (response) {
                            console.log("response in UpdateMessageStatus", response);
                            if (vm.parentCallback) vm.parentCallback({ conversationId: conversationId });
                        }
                    }
                });
            },
            formatDateTime(date) {
                let vm = this;
                return moment(date).format('hh:mm A');
            },
            redirectTOGuestProfile() {
                let vm = this;
                vm.$router.push("/guestProfileDetail/" + vm.guestInfo.guestProfileId);
            },
            sendReplyMail() {
                let vm = this;
                vm.elemHtml = vm.editor.getHTML()
                vm.templateDetail.HTMLObj = vm.elemHtml
                vm.elemHtml = vm.elemHtml.match(/<p[^>]*><\/p[^>]*>/g) ? vm.elemHtml.replace(/<p[^>]*><\/p[^>]*>/g, "") : vm.elemHtml

                //   vm.templateDetail.HTMLObj = vm.messageToSend
                // vm.previewSlectedTemplate("send mail") 
                // vm.$nextTick(function () {
                setTimeout(function () {
                    if (vm.messageToSendTextvals && vm.messageToSendTextvals != null) {
                        // let obj = vm.messages[vm.messages.length-1]

                        vm.sendShowHide = false;
                        let sendEmail
                        let isfromTagUI = false
                        if (vm.selectedSendSource == 1) {
                            sendEmail = vm.lastMessageObject.UserEmail
                            isfromTagUI = false
                        }
                        else {
                            sendEmail = vm.lastMessageObject.ReplyToEmail
                            if (vm.selectedSendSource == 5) {
                                isfromTagUI = true
                            }
                        }
                        let sourceList = vm.sendSourceOptionsList.filter(source => source.SourceId == vm.selectedSendSource)
                        vm.$store.dispatch("dataRequestHandler", {
                            key: "sendReplyMail",
                            params: {
                                ClientName: vm.lastMessageObject.ClientName,
                                ConversationId: vm.conversationId,
                                MessageId: vm.lastMessageObject.MessageId,
                                ReservationId: vm.lastMessageObject.ReservationId,
                                GuestProfileId: vm.lastMessageObject.GuestProfileId,
                                PropertyId: null,
                                ConfirmationNumber: vm.lastMessageObject.ConfirmationNumber,
                                ReplyToEmail: vm.lastMessageObject.UserReplytoEmail,
                                ReplyToCode: "",
                                SourceName: sourceList[0].SourceId == 1 ? "Tempo" : sourceList[0].SourceName,
                                // Message: vm.updateMessageToSend ? vm.updateMessageToSend : vm.messageToSend,
                                Message: vm.updateMessageToSend ? vm.updateMessageToSend : vm.elemHtml,
                                SourceXML: "",
                                UnitName: vm.lastMessageObject.UnitName,
                                ArrivalDate: vm.lastMessageObject.Arrivaldate,
                                DepartureDate: vm.lastMessageObject.Departuredate,
                                mailDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                                replyToName: "",//vm.lastMessageObject.GuestName,
                                mailName: vm.lastMessageObject.LoginUserName,
                                mailUserId: "",//vm.lastMessageObject.SourceUserId,
                                subject: vm.lastMessageObject.Subject ? vm.lastMessageObject.Subject : `Reservation at ${vm.lastMessageObject.UnitName} for ${moment(vm.lastMessageObject.Arrivaldate).format("DD MMM YYYY")} - ${moment(vm.lastMessageObject.Departuredate).format("DD MMM YYYY")}`,
                                toEmail: sendEmail,
                                FromMail: vm.lastMessageObject.FromMail,
                                MailService: vm.lastMessageObject.MailService,
                                Password: vm.lastMessageObject.Password,
                                fromTempo: true,
                                messageID: vm.lastMessageObject.SourceMessageId,
                                isfromTagUI: isfromTagUI,
                                guestName: vm.guestInfo.guestName,
                                GuestFirstName: vm.lastMessageObject.GuestFirstName,
                                GuestLastName: vm.lastMessageObject.GuestLastName,
                                threadId: vm.lastMessageObject.ThreadId,
                                lastMessageObject: vm.lastMessageObject,
                                templateId:vm.selectedTemplate
                            },
                            callback: function (err, response) {
                                if (err) {
                                    console.log("sendReplyMail", err);
                                    vm.sendShowHide = true
                                    return;
                                }
                                if (response) {
                                    console.log("response in sendReplyMail", response);
                                    vm.messageToSend = null
                                    vm.updateMessageToSend = null
                                    vm.elemHtml = null
                                    vm.messageToSendTextvals = null
                                    // $(".editableDivMessage").text() = ""
                                    // document.getElementById('editableDivMessage').innerHTML = ""
                                    vm.sendShowHide = true
                                    vm.editor.setContent()
                                    vm.templateDetail = {}
                                    vm.conversationId = response[1][0].ConversationId
                                    vm.updateReplyStatus(response[1][0].MessageId)
                                }
                            }
                        });
                    }
                }, 300)
            },
            updateReplyStatus(repliedMessageId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "updateReplyStatus",
                    params: {
                        ConversationId: vm.conversationId,
                        repliedMessageId: repliedMessageId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("updateReplyStatus", err);
                            return;
                        }
                        if (response) {
                            console.log("response in updateReplyStatus", response);
                            vm.GetConversationMessageList(vm.conversationId)
                            setTimeout(() => {
                                if (vm.updateReplymessage) vm.updateReplymessage({
                                    conversationId: vm.conversationId,
                                    previousConversationId: vm.previousConversationId,
                                    IsMessageReplied: vm.lastMessageObject.IsMessageReplied,
                                    repliedUsersList: vm.repliedUsersList
                                });
                            }, 500);

                        }
                    }
                });
            },
            Get_TemplatesList() {
                let vm = this;
                vm.showTemplateList = !vm.showTemplateList
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_TemplatesList",
                    params: {
                        StatusId: 1,
                        SearchText: null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Get_TemplatesList", err);
                            return;
                        }
                        if (response) {
                            console.log("response in Get_TemplatesList", response);
                            vm.templateList = response[0];
                        }
                    }
                });
            },
            selectTemplate(template) {
                let vm = this;
                vm.selectedTemplate = template.TemplateId
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetTemplates_Details",
                    params: {
                        TemplateId: template.TemplateId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetTemplates_Details", err);
                            return;
                        }
                        if (response) {
                            console.log("response in GetTemplates_Details", response);
                            vm.templateDetail = response[2][0];
                            vm.previewSlectedTemplate()
                        }
                    }
                });
            },
            previewSlectedTemplate(fromMethod) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "getPreviewSlectedTemplate",
                    params: {
                        templateDetail: vm.templateDetail,
                        ReservationId: vm.lastMessageObject.ReservationId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("getPreviewSlectedTemplate", err);
                            return;
                        }
                        if (response) {
                            console.log("response in getPreviewSlectedTemplate", response);
                            vm.messageToSendTextvals = response.htmlConstruct.textvals.trim()
                            vm.messageToSend = response.htmlConstruct.resmsg.trim()
                            if (response.htmlConstruct.textvals) {
                                vm.elemHtml = vm.editor.getHTML()
                                console.log("prev-vm.elemHtmlprev----", vm.elemHtml)
                                //    if (vm.elemHtml === '<p></p>') vm.elemHtml = ''
                                vm.elemHtml = vm.elemHtml.match(/<p[^>]*><\/p[^>]*>/g) ? vm.elemHtml.replace(/<p[^>]*><\/p[^>]*>/g, "") : vm.elemHtml
                                // vm.elemHtml= vm.elemHtml.match(/<p[^>]*>(?:\s|&nbsp;)*<\/p>/g) ? vm.elemHtml.replace(/<p[^>]*>(?:\s|&nbsp;)*<\/p>/g, "") : vm.elemHtml

                                vm.$emit('input', vm.elemHtml)
                                vm.elemHtml += vm.messageToSend
                                vm.editor.setContent(vm.elemHtml)
                                console.log("vm.messageToSend--", vm.messageToSend, vm.messageToSendTextvals)
                                // vm.editor.setContent(vm.messageToSend)
                            } else {
                                vm.editor.setContent()
                            }
                            if (!fromMethod && !response.htmlConstruct.textvals) {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "Warning!",
                                    message: "No template Detail"
                                });
                            }
                        }
                    }
                });
            },
            updateHTML: function (e) {
                let vm = this;
                vm.updateMessageToSend = e.target.innerHTML
                console.log("vm.updateMessageToSend == ", vm.updateMessageToSend)
                // this.$emit(vm.messageToSend, e.target.innerHTML);
            },
            addImageToTemplate(command){
                const src = prompt('Enter the url of your image here')
                if (src !== null) {
                command({ src })
              }
            },
            initEditor() {
                let vm = this;

                if (vm.editor) {
                    vm.editor.destroy()
                }


                this.editor = new Editor({
                    extensions: [
                        new Placeholder(),
                        new Blockquote(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({ levels: [1, 2, 3] }),
                        new BulletList(),
                        new OrderedList(),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Link(),
                        new Strike(),
                        new Underline(),
                        new History(),
                        new HorizontalRule(),
                        new Table({
                          resizable: true,
                        }),
                        new TableCell(),
                        new TableHeader(),
                        new TableRow(),
                        new Image(),

                        new Mention({
                            // matcher: {
                            //   char: '^',
                            // },
                            // a list of all suggested items
                            items: () => [],
                            // is called when a suggestion starts
                            onEnter: ({
                                items, query, range, command, virtualNode,
                            }) => {
                                vm.query = query
                                vm.filteredUsers = items
                                vm.suggestionRange = range
                                vm.renderPopup(virtualNode)
                                // we save the command for inserting a selected mention
                                // this allows us to call it inside of our custom popup
                                // via keyboard navigation and on click
                                vm.insertMention = command
                            },
                            // is called when a suggestion has changed
                            onChange: ({
                                items, query, range, virtualNode,
                            }) => {
                                vm.query = query
                                vm.filteredUsers = items
                                vm.suggestionRange = range
                                vm.navigatedUserIndex = 0
                                vm.renderPopup(virtualNode)
                            },
                            // is called when a suggestion is cancelled
                            onExit: () => {
                                // reset all saved values
                                vm.query = null
                                vm.filteredUsers = []
                                vm.suggestionRange = null
                                vm.navigatedUserIndex = 0
                                vm.destroyPopup()
                            },
                            onKeyDown: ({ event }) => {
                                // pressing up arrow
                                if (event.keyCode === 38) {
                                    vm.upHandler()
                                    return true
                                }
                                // pressing down arrow
                                if (event.keyCode === 40) {
                                    vm.downHandler()
                                    return true
                                }
                                // pressing enter
                                if (event.keyCode === 13) {
                                    vm.enterHandler()
                                    return true
                                }
                                return false
                            },
                            // is called when a suggestion has changed
                            // this function is optional because there is basic filtering built-in
                            // you can overwrite it if you prefer your own filtering
                            // in this example we use fuse.js with support for fuzzy search
                            onFilter: (items, query) => {
                                if (!query) {
                                    return items
                                }
                                const fuse = new Fuse(items, {
                                    threshold: 0.2,
                                    keys: ['label'],
                                })
                                return fuse.search(query)
                            },

                        }),

                    ],
                    onUpdate: ({ getJSON, getHTML, state, transaction }) => {
                        // vm.templateDetail.JSONObj = getJSON()
                        // vm.templateDetail.HTMLObj = getHTML()                        

                        vm.messageToSend = getHTML()
                        vm.elemHtml = getHTML()

                        vm.messageToSendTextvals = vm.editor.state.doc.textContent.trim()
                        console.log("editor.statet", vm.elemHtml)
                    },
                    // content: vm.entityNotificationTemplate.templateHtml,

                }),

                    vm.editor.setContent()
                console.log("editor.state.doc.textContent", vm.editor.state.doc.textContent)
                // if (vm.templateDetail && vm.templateDetail.HTMLObj) {
                //     vm.editor.setContent(vm.templateDetail.HTMLObj)
                // }

            },
            drop: function (event) {
                let vm = this;
                event.preventDefault();
                console.log("vm.selectedParamvm.selectedParam", vm.selectedParam)
                var span = document.createElement("span");
                var node = document.createTextNode(vm.selectedParam.label);
                span.appendChild(node);
                span.setAttribute("class", "mention");
                span.setAttribute("data-mention-id", vm.selectedParam.id);
                event.target.appendChild(span);
            },
            allowDrop: function (event) {
                event.preventDefault();
            },
            getRefs() {
                let vm = this;
                console.log("getRefs = ", this.$refs)
                for (let key of Object.keys(vm.groupedMessagesList)) {
                    for (let msg of vm.groupedMessagesList[key].messages) {
                        let refval = `contentheight${msg.indexval}`
                        // console.log(Object.keys(this.$refs), refval)
                        msg.contentheight = this.$refs[`contentheight${msg.indexval}`] && this.$refs[`contentheight${msg.indexval}`][0] ? this.$refs[`contentheight${msg.indexval}`][0].offsetHeight : 0
                    }
                }
            }
        },
        updated: function () {
            let vm = this;
            // vm.nextTick(() => {
            vm.footerHeightString = $('.ProseMirror').height()
            // });
            // console.log('updated, clientHeight =', this.height); // seems ok
        },

        computed: {
            newConversation() {
                return this.$store.getters.getConversation;
            },
            getRefreshMessageNotificationPanelStatus() {
                return this.$store.getters.getRefreshMessageNotificationPanel();
            },
        },
        created() {
            let vm = this;
            vm.$store.state.bus.$on("getNoficicationConversation", function (dataobj) {
                vm.reservationId = dataobj.ReservationId
                vm.GetConversationMessageList(dataobj.ConversationId);
            });
        },
        watch: {

            conversationId: {
                handler: function (conversationId, oldVal) {
                    console.log("oldVal = ", oldVal)
                    this.previousConversationId = oldVal
                    // if (conversationId) {
                    this.GetConversationMessageList(conversationId);
                    // this.initEditor()
                    if (this.editor) {
                        this.editor.setContent()
                    }
                    this.messageToSend = ""
                    // }
                },
                deep: true,
                immediate: true
            },
            messageFilterType: {
                handler: function (messageFilterType, oldVal) {
                    this.previousMessageFilterType = oldVal
                },
                deep: true
            },
            footerHeightString: {
                handler: function (newHeight, oldHeight) {
                    console.log("newHeight", newHeight, "=", oldHeight)
                    if (newHeight == 38) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 307px)" });
                        $(".guest-chat-info").css({ "margin-top": "-38px" });
                        // $(".chat-box.resdetail-chat-box .guest-chat .guest-chat-body").css({ "height":" calc(100vh - 228px)" });
                    }
                    else if (newHeight == 38.5) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 307px)" });
                        $(".guest-chat-info").css({ "margin-top": "-38px" });
                        // $(".chat-box.resdetail-chat-box .guest-chat .guest-chat-body").css({ "height":" calc(100vh - 228px)" });
                    }
                    else if (newHeight == 76) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 345px)" });
                        $(".guest-chat-info").css({ "margin-top": "-76px" });
                    }
                    else if (newHeight == 77) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 345px)" });
                        $(".guest-chat-info").css({ "margin-top": "-76px" });
                    }
                    else if (newHeight == 108) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 345px)" });
                        $(".guest-chat-info").css({ "margin-top": "-114px" });
                    }
                    else if (newHeight == 114) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 382px)" });
                        $(".guest-chat-info").css({ "margin-top": "-114px" });
                    }
                    else if (newHeight == 115.5) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 382px)" });
                        $(".guest-chat-info").css({ "margin-top": "-114px" });
                    }
                    else if (newHeight == 152) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 420px)" });
                        $(".guest-chat-info").css({ "margin-top": "-152px" });
                    }
                    else if (newHeight == 154) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 420px)" });
                        $(".guest-chat-info").css({ "margin-top": "-152px" });
                    }
                    else if (newHeight == 190) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 459px)" });
                        $(".guest-chat-info").css({ "margin-top": "-190px" });
                    }
                    else if (newHeight == 192.5) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 459px)" });
                        $(".guest-chat-info").css({ "margin-top": "-190px" });
                    }
                    else if (newHeight == 228) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 496px)" });
                        $(".guest-chat-info").css({ "margin-top": "-228px" });
                    }
                    else if (newHeight == 231) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 496px)" });
                        $(".guest-chat-info").css({ "margin-top": "-228px" });
                    }
                    else if (newHeight == 253) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 522px)" });
                        $(".guest-chat-info").css({ "margin-top": "-253px" });
                    }

                    // if (newHeight && oldHeight && newHeight > oldHeight) {
                    //     // alert("height up")
                    //     $(".guest-chat-body").css({ "height": `${$(".guest-chat-body").height() - 20}` });
                    // } else if (newHeight && oldHeight && newHeight < oldHeight) {
                    //     // alert("height down")
                    //     $(".guest-chat-body").css({ "height": `${$(".guest-chat-body").height() + 40}` });
                    // }
                },
                deep: true
            },
            messageToSend: {
                handler: function (newHeight, oldHeight) {
                    this.footerHeightString = $('.ProseMirror').height()
                },
                deep: true
            },
            getRefreshMessageNotificationPanelStatus(oldVal, newVal) {
                console.log(this.getRefreshMessageNotificationPanelStatus);
                console.log("this.newConversation.conversationObj = ", this.newConversation.conversationObj)
                console.log("this.getRefreshMessageNotificationPanelStatus && this.newConversation.conversationObj &&(this.conversationId == this.newConversation.conversationObj.ConversationId || this.reservationId == this.newConversation.conversationObj.EventGeneratedId) == ", this.getRefreshMessageNotificationPanelStatus && this.newConversation.conversationObj && (this.conversationId == this.newConversation.conversationObj.ConversationId || this.reservationId == this.newConversation.conversationObj.EventGeneratedId))
                if (this.getRefreshMessageNotificationPanelStatus && this.newConversation.conversationObj && (this.conversationId == this.newConversation.conversationObj.ConversationId || this.reservationId == this.newConversation.conversationObj.EventGeneratedId)) {
                    this.GetConversationMessageList(this.conversationId);
                }
            }

            // previousConversationId: {
            //     handler: function (conversationId, oldVal) {
            //         if (conversationId && conversationId != oldVal) {
            //             this.UpdateMessageStatus(conversationId);
            //         }
            //     },
            //     deep: true
            // }
        },
        mounted() {

            // console.log("messageInboxDetail", document.querySelector(".guest-chat-body").scrollHeight);
            // setTimeout(function () {
            //     $("#chat-body").scrollTop($('#chat-body')[0].scrollHeight);
            //     $(".guest-chat-body").scrollTop($('.guest-chat-body')[0].scrollHeight);
            // }, 500);
            let vm = this;
            vm.initEditor();
            if (vm.conversationId) {
                // vm.GetConversationMessageList();
            }
            $(document).click(function (e) {
                // alert("hai")
                vm.showTemplateList = false
                console.log("this.showTemplateList", vm.showTemplateList)
            })
            $(document).ready(function(){
                $('[data-toggle="tooltip"]').tooltip();   
            });
        }
    };
</script>
<style>
    /* .date {
        text-align: center;
        color: red;
    } */
    .divider {
        text-align: center;
    }

    .divider span {
        display: inline-block;
        padding: 6px 12px;
        text-align: center;
        line-height: 1;
        background: gray;
        color: #fff;
        border-radius: 6px;
    }

    .sticky {
        position: relative;
    }

    .sticky span {
        position: fixed;
        top: 135px;
        width: auto;
    }

    .ProseMirror p.is-empty:first-child::before {
        content: "Write a message";
        float: left;
        color: #adb5bd;
        pointer-events: none;
        height: 0;
    }
</style>